// WorkContainerのサイズ定数定義
// 異なる表示サイズのバリエーションを管理

export const WORK_CONTAINER_SIZES = {
  // 標準サイズ（内部レンダリング用）
  STANDARD: {
    WIDTH: 980,
    HEIGHT: 730,
  },

  // 大サイズ（4分割表示用）
  LARGE: {
    WIDTH: 1280,
    HEIGHT: 730,
  },

  // コンパクトサイズ（6分割表示用）
  COMPACT: {
    WIDTH: 1100,
    HEIGHT: 730,
  },
};
